import React, { useEffect, useState } from "react";
import classes from './Receipts.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import { useLocation, useNavigate } from 'react-router-dom';
import svg from "../../Assets/SVG.jpg";
import filter from "../../Assets/SVG (1).png";
import exports from "../../Assets/file-export.png";
import invoice from "../../Assets/invoice-04.png";
import Modal from './Modal'
import vector from "../../Assets/Vector.svg";
import Footer from "../../Components/Footer/Footer";
import { Eye } from 'lucide-react';
import { Link } from "react-router";
import axios from "axios";
import { BASE_URL } from "../../Components/API/Api";
import Swal from "sweetalert2";
import { Form } from 'react-bootstrap';
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import CurrencyInput from "react-currency-input-field";
import verified from "../../Assets/verified.svg";
import crop from "../../Assets/repoort.png";

const Receipts = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const [show2, setShow2] = useState(false);
    const [customerName, setCustomerName] = useState("");
    const handleClose2 = () => setShow2(false);
    const [paymentDate, setPaymentDate] = useState("");
    const [description, setDescription] = useState("");
    const [amount, setAmount] = useState("");
    const [currencyOptions, setCurrencyOptions] = useState([]);
    const [bankOptions, setBankOptions] = useState([]);
    const [bankOptions2, setBankOptions2] = useState([]);
    // Payment mode now selected via radio buttons with fixed IDs 1-4
    const [selectedCurrency, setSelectedCurrency] = useState(null);
    const [selectedBank, setSelectedBank] = useState(null);
    const [selectedBank2, setSelectedBank2] = useState(null);
    // Selected payment method id (1: Bank Transfer, 2: Cheque, 3: Teller, 4: Cash)
    const [selectedPaymentMethodId, setSelectedPaymentMethodId] = useState(null);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [customerList, setCustomerList] = useState([]);
    const [invoiceOptions, setInvoiceOptions] = useState([]);
    const [addpaymenntLoad, setAddPaymenntLoad] = useState(false);
    const [addpaymenntLoad2, setAddPaymenntLoad2] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [selectedRadio, setSelectedRadio] = useState("");
    const [tellerNo, setTellerNo] = useState("");
    const [outstandingCredit, setOutstandingCredit] = useState("0.00");

    const [rows, setRows] = useState([]);
    const [loadingTable, setLoadingTable] = useState(true);
    const [selectedMetrics, setSelectedMetrics] = useState(null);
    // ----------------- Helpers -----------------
    // Convert incoming value (string with commas/spaces or number) to a Number or NaN
    const toNumber = (val) => {
        if (val === null || val === undefined) return NaN;
        if (typeof val === 'number') return val;
        if (typeof val === 'string') {
            // Remove commas and whitespace used as group separators (e.g. "1,234,567.00" or "1,234, 567.00")
            const cleaned = val.replace(/,/g, '').replace(/\s+/g, '').trim();
            if (cleaned === '') return NaN;
            const n = Number(cleaned);
            return isNaN(n) ? NaN : n;
        }
        return NaN;
    };

    // Format a value safely to "1,234.00" or return fallback
    const formatAmount = (val, { fallback = "0.00", allowEmpty = false } = {}) => {
        const num = toNumber(val);
        if (isNaN(num)) return allowEmpty ? "" : fallback;
        return num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    // ----------------- Print helper -----------------
    const openPrintReceipt = (payload, apiData) => {
        try {
            const customerDisplay = selectedCustomer?.__isNew__ ? selectedCustomer?.label : selectedCustomer?.label;
            const amountDisplay = formatAmount(payload?.amount || amount || 0);
            const paymentModeDisplay = ({ 1: 'Bank Transfer', 2: 'Cheque', 3: 'Teller', 4: 'Cash' })[payload?.mode] || '';
            const currencyDisplay = currencyOptions?.find(c => c.value === payload?.currency)?.label || selectedCurrency?.label || '';
            const bankDisplay = bankOptions?.find(b => b.value === payload?.bank)?.label || selectedBank?.label || '';
            const issuedAt = new Date().toLocaleString();

            const receiptNo = apiData?.receipt_no || apiData?.reference || apiData?.id || '';
            const doc = window.open('', '_blank');
            if (!doc) return;
            doc.document.write(`
<!doctype html>
<html>
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <title>Payment Receipt</title>
    <style>
      body { font-family: Arial, sans-serif; padding: 24px; color: #111827; }
      .hdr { display:flex; justify-content:space-between; align-items:center; margin-bottom:16px; }
      .brand { font-size:18px; font-weight:700; }
      .muted { color:#6B7280; }
      .card { border:1px solid #E5E7EB; border-radius:8px; padding:16px; }
      .row { display:flex; gap:24px; margin:8px 0; }
      .col { flex:1; }
      h2 { margin:0 0 8px 0; font-size:16px; }
      table { width:100%; border-collapse:collapse; margin-top:12px; }
      td { padding:8px 0; border-bottom:1px solid #F3F4F6; }
      .right { text-align:right; }
      .total { font-weight:700; }
      .footer { margin-top:24px; font-size:12px; color:#6B7280; }
      @media print { .noprint { display:none; } }
    </style>
  </head>
  <body>
    <div class="hdr">
      <div class="brand">Payment Receipt</div>
      <div class="muted">${issuedAt}</div>
    </div>
    <div class="card">
      <div class="row">
        <div class="col">
          <h2>Receipt To</h2>
          <div>${customerDisplay || ''}</div>
        </div>
        <div class="col">
          <h2>Receipt Info</h2>
          <div>Receipt No: ${receiptNo}</div>
          <div>Mode: ${paymentModeDisplay}</div>
        </div>
      </div>
      <table>
        <tr>
          <td>Description</td>
          <td class="right">${payload?.description || ''}</td>
        </tr>
        <tr>
          <td>Currency</td>
          <td class="right">${currencyDisplay}</td>
        </tr>
        <tr>
          <td>Bank</td>
          <td class="right">${bankDisplay}</td>
        </tr>
        <tr>
          <td>Teller No</td>
          <td class="right">${payload?.teller_number || ''}</td>
        </tr>
        <tr class="total">
          <td>Total Amount</td>
          <td class="right">${amountDisplay}</td>
        </tr>
      </table>
    </div>
    <div class="footer">
      Generated by Promix Accounting
    </div>
    <div class="noprint" style="margin-top:16px;">
      <button onclick="window.print()" style="padding:8px 12px;">Print</button>
    </div>
    <script>window.onload = function(){ window.print(); };</script>
  </body>
</html>`);
            doc.document.close();
        } catch (e) {
            // noop if popup blocked
        }
    };

    const [selectedRows, setSelectedRows] = useState([]);
    const allSelected = selectedRows.length === rows.length;
    const [formData, setFormData] = useState({})
    const handleSelectAll = () => {
        if (allSelected) {
            setSelectedRows([]);
        } else {
            setSelectedRows(rows.map((_, i) => i));
        }
    };

    const handleSelectRow = (index) => {
        if (selectedRows.includes(index)) {
            setSelectedRows(selectedRows.filter(i => i !== index));
        } else {
            setSelectedRows([...selectedRows, index]);
        }
    };

    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };

    // Fetch receipts for table
    useEffect(() => {
        const fetchReceipts = async () => {
            setLoadingTable(true);
            try {
                const token = localStorage.getItem("authToken");
                const res = await axios.get(`${BASE_URL}/v1/get_payment_to_customer`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                });

                const apiRows = Array.isArray(res.data?.data) ? res.data.data : [];
                const mapped = apiRows.map((item) => {
                    const method = (item?.mode?.name || "").trim();
                    const account = item?.bank?.gl_name || "";
                    const refNo = item?.receipt_number || item?.invoice_number || item?.uuid || (item?.id ? `REC-${item.id}` : "");
                    let status = "Pending";
                    const bal = parseFloat(item?.balance);
                    if (!isNaN(bal)) {
                        status = bal === 0 ? "Paid" : "Pending";
                    }
                    return {
                        ref: refNo || "—",
                        customer: item?.customer?.name || "—",
                        date: item?.transaction_date || "—",
                        dueDate: item?.due_date || "—",
                        amount: formatAmount(item?.amount, { fallback: "0.00" }),
                        method: method || "—",
                        reference: item?.invoice_number || item?.uuid || "—",
                        account: account || "—",
                        status,
                        actions: "Invoice",
                        _raw: item,
                    };
                });
                setRows(mapped);
            } catch (err) {
                setRows([]);
            } finally {
                setLoadingTable(false);
            }
        };
        fetchReceipts();
    }, []);

    useEffect(() => {


        const fetchMetrics = async () => {
            try {
                const token = localStorage.getItem("authToken");
                const res = await axios.get(`${BASE_URL}/v1/metrics/receipt-metrics`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                });
                if (res.data && res.data.status && res.data.data) {
                    // Remove Array.isArray check since data is an object
                    setSelectedMetrics(res.data.data);
                }
            } catch (err) {
                setSelectedMetrics(null);
            }
        };
        fetchMetrics();
    }, []);

    // Fetch currencies
    useEffect(() => {
        const fetchCurrencies = async () => {
            try {
                const token = localStorage.getItem("authToken");
                const res = await axios.get(`${BASE_URL}/v1/fetch-all-currencies`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                });
                const options = Array.isArray(res.data?.data)
                    ? res.data.data.map(item => ({ value: item.id, label: item.name || item.code }))
                    : [];
                setCurrencyOptions(options);
            } catch (err) {
                setCurrencyOptions([]);
            }
        };
        fetchCurrencies();
    }, []);

    // Fetch cash and bank (credit select)
    useEffect(() => {
        const fetchBank = async () => {
            try {
                const token = localStorage.getItem("authToken");
                const res = await axios.get(`${BASE_URL}/v1/get-cash-and-bank`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                });
                const options = Array.isArray(res.data?.data)
                    ? res.data.data.map(item => ({ value: item.id, label: item.gl_name }))
                    : [];
                setBankOptions(options);
            } catch (err) {
                setBankOptions([]);
            }
        };
        fetchBank();
    }, []);

    // Fetch cash and bank (debit select)
    useEffect(() => {
        const fetchBank2 = async () => {
            try {
                const token = localStorage.getItem("authToken");
                const res = await axios.get(`${BASE_URL}/v1/get-cash-and-bank`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                });
                const options = Array.isArray(res.data?.data)
                    ? res.data.data.map(item => ({ value: item.id, label: item.gl_name }))
                    : [];
                setBankOptions2(options);
            } catch (err) {
                setBankOptions2([]);
            }
        };
        fetchBank2();
    }, []);

    // Payment modes are static radios now; no fetch required

    // Fetch customers for "Receipt to" select
    useEffect(() => {
        const fetchCustomers = async () => {
            try {
                const token = localStorage.getItem("authToken");
                const res = await axios.get(`${BASE_URL}/v1/customer`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                });
                const optionsSource = Array.isArray(res.data?.data?.data)
                    ? res.data.data.data
                    : Array.isArray(res.data?.data)
                        ? res.data.data
                        : [];
                setCustomerList(optionsSource);
                const options = optionsSource.map(item => ({
                    value: item.id,
                    label: item.name || `Customer #${item.id}`,
                    balance: item.balance
                }));
                setCustomerOptions(options);
            } catch (err) {
                setCustomerOptions([]);
                setCustomerList([]);
            }
        };
        fetchCustomers();
    }, []);

    const addPayment2 = async () => {
        setAddPaymenntLoad2(true);
        try {
            const token = localStorage.getItem("authToken");
            const receiptForParam = selectedCustomer?.__isNew__
                ? selectedCustomer?.label
                : selectedCustomer?.value;

            const response = await axios.post(
                `${BASE_URL}/v1/customer_payment_receipt`,
                {
                    receipt_for: receiptForParam,
                    description: description,
                    amount: amount,
                    mode: selectedPaymentMethodId,
                    currency: selectedCurrency?.value,
                    teller_number: tellerNo,
                    bank: selectedBank?.value,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                });

            setIsOpen(false);

            Swal.fire({
                imageUrl: verified,
                title: 'Success!',
                text: response.data.message,
                showCancelButton: true,
                confirmButtonText: "Print Receipt",
                cancelButtonText: "Close",
                imageWidth: 48,
                imageHeight: 48,
                customClass: {
                    title: classes.myTitle,
                    popup: classes.myText,
                    confirmButton: classes.myButton,
                    cancelButton: classes.myDeclineButton,
                },
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const payload = {
                        receipt_for: receiptForParam,
                        description: description,
                        amount: amount,
                        mode: selectedPaymentMethodId,
                        currency: selectedCurrency?.value,
                        teller_number: tellerNo,
                        bank: selectedBank?.value,
                    };

                    const metadata = {
                        customer_label: selectedCustomer?.__isNew__ ? selectedCustomer?.label : selectedCustomer?.label,
                        payment_mode_label: ({ 1: 'Bank Transfer', 2: 'Cheque', 3: 'Teller', 4: 'Cash' })[payload?.mode] || '',
                        currency_label: currencyOptions?.find(c => c.value === payload?.currency)?.label || selectedCurrency?.label || '',
                        bank_label: bankOptions?.find(b => b.value === payload?.bank)?.label || selectedBank?.label || '',
                    };

                    navigate('/print-customer-receipt', {
                        state: {
                            receipt: payload,
                            api: response?.data?.data,
                            metadata,
                        }
                    });
                }
            });

            setDescription("");
            setAmount("");
            setCustomerName("");
            setPaymentDate("");
            setSelectedBank(null);
            setSelectedBank2(null);
            setSelectedCurrency(null);
            setSelectedCustomer(null);
            setSelectedPaymentMethodId(null);

        } catch (error) {
            let errorMessage = "An error occurred. Please try again.";
            if (
                error.response &&
                error.response.data &&
                error.response.data.message
            ) {
                if (typeof error.response.data.message === "string") {
                    errorMessage = error.response.data.message;
                } else if (Array.isArray(error.response.data.message)) {
                    errorMessage = error.response.data.message.join("; ");
                } else if (typeof error.response.data.message === "object") {
                    errorMessage = JSON.stringify(error.response.data.message);
                }
                Swal.fire({
                    imageUrl: crop,
                    imageWidth: 48,
                    imageHeight: 48,
                    title: "Failed!",
                    confirmButtonText: "Okay",
                    text: JSON.stringify(error.response.data.message),
                    customClass: {
                        title: classes.myTitle,
                        popup: classes.myText,
                        confirmButton: classes.myDeclineButton,
                    },
                    allowOutsideClick: false,
                    preConfirm: () => {
                        Swal.close();
                    },
                });
            }
        } finally {
            setAddPaymenntLoad2(false);
        }
    };

    // Prevent background scrolling when modal open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => { document.body.style.overflow = 'unset'; };
    }, [isOpen]);

    // ----------------- FIXED: Fetch customer's balance when selectedCustomer changes -----------------
    useEffect(() => {
        // If no customer at all, clear outstanding
        if (!selectedCustomer) {
            setOutstandingCredit("0.00");
            return;
        }

        // If user just created a new customer (CreatableSelect), there's no balance
        if (selectedCustomer.__isNew__) {
            setOutstandingCredit("0.00");
            return;
        }

        // Prefer balance from selectedCustomer (from options), fallback to customerList
        let balance = selectedCustomer.balance;

        if (typeof balance === "undefined") {
            const customerObj = customerList.find(
                c => String(c.id) === String(selectedCustomer.value)
            );
            balance = customerObj?.balance ?? 0;
        }

        // Provide CurrencyInput with a raw numeric string (no commas) to avoid NaN
        const num = toNumber(balance);
        const raw = isNaN(num) ? "0.00" : num.toFixed(2);
        setOutstandingCredit(raw);

    }, [selectedCustomer, customerList]);

    // Autofill customer details and compute fields on selection


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handlePaymentMethodChange = (id) => {
        setSelectedPaymentMethodId(id);
    };

    // Compute net payable only when any deduction is entered
    useEffect(() => {
        const base = toNumber(outstandingCredit) || 0;
        const wht = toNumber(formData.withholdingTax);
        const other = toNumber(formData.otherDeductions);
        const hasDeductions = (!isNaN(wht) && wht > 0) || (!isNaN(other) && other > 0);
        if (!hasDeductions) {
            setFormData(prev => ({ ...prev, netPayableAmount: '' }));
            return;
        }
        const safeWht = isNaN(wht) ? 0 : wht;
        const safeOther = isNaN(other) ? 0 : other;
        const net = Math.max(base - safeWht - safeOther, 0);
        setFormData(prev => ({ ...prev, netPayableAmount: net.toFixed(2) }));
    }, [outstandingCredit, formData.withholdingTax, formData.otherDeductions]);

    // When customer changes, autofill phone, email, invoice numbers and invoice date
    useEffect(() => {
        if (!selectedCustomer || selectedCustomer.__isNew__) {
        setFormData(prev => ({
            ...prev,
                phone: '',
                email: '',
                invoiceNumbers: '',
                invoiceDate: ''
            }));
            setInvoiceOptions([]);
            setSelectedInvoice(null);
            return;
        }
        const customerObj = customerList.find(c => String(c.id) === String(selectedCustomer.value));
        if (!customerObj) return;
        const phone = customerObj.phone || '';
        const email = customerObj.email || '';
        const ledgers = Array.isArray(customerObj.ledgers) ? customerObj.ledgers : [];
        // Build invoice dropdown options from ledgers
        const uniqueInvoices = Array.from(new Set(ledgers.map(l => l.invoice_number).filter(Boolean)));
        const invOptions = uniqueInvoices.map(inv => ({ value: inv, label: inv }));
        setInvoiceOptions(invOptions);
        // Keep the legacy string field empty until user selects from dropdown
        const invoiceNumbers = '';
        // pick latest created_at among ledgers if available
        const latest = ledgers
            .map(l => ({ d: new Date(l.created_at), raw: l.created_at }))
            .sort((a, b) => b.d - a.d)[0];
        const invoiceDate = latest ? latest.raw.substring(0, 10) : '';
        setFormData(prev => ({
            ...prev,
            phone,
            email,
            invoiceNumbers,
            invoiceDate
        }));
    }, [selectedCustomer, customerList]);

    // Keep formData.invoiceNumbers in sync with dropdown selection (comma-separated)
    useEffect(() => {
        if (!selectedInvoice || (Array.isArray(selectedInvoice) && selectedInvoice.length === 0)) {
            setFormData(prev => ({ ...prev, invoiceNumbers: '' }));
            return;
        }
        const values = Array.isArray(selectedInvoice) ? selectedInvoice.map(o => o.value) : [selectedInvoice.value];
        setFormData(prev => ({ ...prev, invoiceNumbers: values.join(', ') }));
    }, [selectedInvoice]);

    return (
        <div>

            <HeaderNav activePage={pageMap[location.pathname]} />

            <div className={classes.Container}>
                <div className={classes.actions}>
                    <Link to='/transactions/sales-invoice/sales'><button className={classes.btns}>Sales Invoice</button></Link>
                    <Link to='/inventory/purchaseOrder'><button className={classes.btns}>Purchase order</button></Link>
                    <button className={classes.btnst}>Receipts</button>
                    <Link to='/settings/product-services'><button className={`${classes.btns} ${classes.greens}`}>Product & Services</button></Link>
                </div>

                <header className={classes.Header}>
                    <h2 className={classes.Title}>Receipts</h2>
                    <h1 className={classes.Titles}>
                        Track and manage all incoming payments from customers.
                    </h1>
                </header>

                <div className={classes.entrjj}>
                    <div className={classes.allkads}>
                        <div className={classes.thrdkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Total Receipts</p>
                                <p className={classes.kdptg1}>{selectedMetrics?.total_receipt?.toLocaleString() ?? '0'}</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>This month</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.frtkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Outstanding</p>
                                <p className={classes.kdptg2}>{selectedMetrics?.outstanding?.toLocaleString() ?? '0'}</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Outstanding</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.fiftkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Total Amount</p>
                                <p className={classes.kdptg3}>{selectedMetrics?.total_amount?.toLocaleString() ?? '0'}</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Total Amount</p>
                                </div>
                            </div>
                        </div>
                        {/* <div className={classes.frstkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>This month</p>
                                <p className={classes.kdptg4}>15</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>This month</p>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>

                <div className={classes.headerActions}>
                    <div className={classes.actionsRight}>
                        <div className={classes.inputWrapper}>
                            <img src={svg} alt="svg" className={classes.searchIcon} />
                            <input type="text" className={classes.searchBar} placeholder="Search sales..." />
                        </div>
                        <div className={classes.selectWrapper}>
                            <select className={classes.dropdown}>
                                <option value="">All methods</option>
                                <option value="Paid">Paid</option>
                                <option value="Pending">Pending</option>
                                <option value="Overdue">Overdue</option>
                                <option value="Draft">Draft</option>
                            </select>
                            <span className={classes.dropdownArrow}>▼</span>
                        </div>
                        <div className={classes.inputWrapper}>
                            <img src={filter} alt="Filter" className={classes.filterIcon} />
                            <input type="text" className={classes.secondBar} placeholder="Filter" />
                        </div>
                    </div>

                    <button className={classes.export}>
                        <img src={exports} alt="exports" className={classes.exportIcon} />
                        Export</button>
                    <button className={classes.btnss} onClick={() => setIsOpen(true)}>
                        <img src={invoice} alt="invoice" className={classes.invoiceIcon} />
                        New Receipt</button>
                </div>


                <Modal
                    isOpen={isOpen}
                    onClose={() => setIsOpen(false)}
                    title="New Receipt"
                    subtitle="Brookes Professional Services Limited — use this form to submit customer payment and capture pending payments and balances."
                    addPayment2={addPayment2}
                    addpaymenntLoad2={addpaymenntLoad2}
                    invoiceOptions={invoiceOptions}
                    selectedInvoice={selectedInvoice}
                    setSelectedInvoice={setSelectedInvoice}
                    setAmount={setAmount}
                    amount={amount}
                    paymentDate={paymentDate}
                    setPaymentDate={setPaymentDate}
                    description={description}
                    setDescription={setDescription}
                    currencyOptions={currencyOptions}
                    selectedCurrency={selectedCurrency}
                    setSelectedCurrency={setSelectedCurrency}
                    bankOptions={bankOptions}
                    selectedBank={selectedBank}
                    setSelectedBank={setSelectedBank}
                    bankOptions2={bankOptions2}
                    selectedBank2={selectedBank2}
                    setSelectedBank2={setSelectedBank2}
                    classes={classes}
                >
                    <Form className={classes.compactForm}>
                        <Form.Group controlId="exampleForm.ControlInput1">
                            <div className={classes.sectionTitle}>1. Customer Information</div>

                            <div className={classes.customerInformationflx}>
                                <div className={classes.compactRowtackled}>
                                    <label className={classes.formLabel}>Receipt from:</label>
                                    <CreatableSelect
                                        options={customerOptions}
                                        value={selectedCustomer}
                                        onChange={(option) => {
                                            setSelectedCustomer(option);
                                        }}
                                        placeholder="Search, select, or type a new customer name"
                                        isClearable
                                        classNamePrefix="react-select"
                                        required
                                        className={classes.fullWidth}
                                        formatCreateLabel={(inputValue) => `Use "${inputValue}"`}
                                    />
                                </div>
                                <div className={classes.compactRowtackled}>
                                    <label className={classes.formLabel}>Description:</label>
                                    <Form.Control
                                        as="textarea"
                                        value={description}
                                        rows={1}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            const filteredValue = value.replace(/[^a-zA-Z0-9.@,\- ]/g, '');
                                            setDescription(filteredValue);
                                        }}
                                        required
                                        className={`${classes.fullWidth} ${classes.descriptionTextarea}`}
                                    />
                                </div>
                            </div>

                            <div className={classes.customerInformationflx}>
                                <div className={classes.formGroup}>
                                    <label className={classes.formLabel}>Phone:</label>
                                    <input
                                        type="number"
                                        name="phone"
                                        value={formData.phone || ''}
                                        onChange={handleInputChange}
                                        placeholder="+234 9045 456 4049"
                                        className={`${classes.formInput} ${selectedCustomer && !selectedCustomer.__isNew__ ? classes.grayedOut : ''}`}
                                        readOnly={!!selectedCustomer && !selectedCustomer.__isNew__}
                                        disabled={!!selectedCustomer && !selectedCustomer.__isNew__}
                                        required
                                    />
                                </div>
                                <div className={classes.formGroup}>
                                    <label className={classes.formLabel}>Email:</label>
                                    <input
                                        type="text"
                                        name="email"
                                        value={formData.email || ''}
                                        onChange={handleInputChange}
                                        placeholder="customer@email.com"
                                        className={`${classes.formInput} ${selectedCustomer && !selectedCustomer.__isNew__ ? classes.grayedOut : ''}`}
                                        readOnly={!!selectedCustomer && !selectedCustomer.__isNew__}
                                        disabled={!!selectedCustomer && !selectedCustomer.__isNew__}
                                        required
                                    />
                                </div>
                            </div>

                            {/* Section 2: Invoice/Payment Details */}
                            <div className={classes.formSection}>
                                <div className={classes.sectionTitle}>2. Invoice / Payment Details</div>
                                <div className={classes.flexy}>
                                    <div className={classes.formGroup}>
                                        <label className={classes.formLabel}>Invoice Number(s)</label>
                                        <Select
                                            options={invoiceOptions}
                                            value={selectedInvoice}
                                            onChange={setSelectedInvoice}
                                            isMulti
                                            isClearable
                                            placeholder="Select invoice number(s)"
                                            classNamePrefix="react-select"
                                            className={classes.formInput}
                                        />
                                    </div>

                                    <div className={classes.twoColumnGrid}>
                                        <div className={classes.formGroup}>
                                            <label className={classes.formLabel}>Invoice Date</label>
                                            <input
                                                type="date"
                                                name="invoiceDate"
                                                value={formData.invoiceDate || ''}
                                                onChange={handleInputChange}
                                                className={`${classes.formInput} ${selectedCustomer && !selectedCustomer.__isNew__ ? classes.grayedOut : ''}`}
                                                readOnly={!!selectedCustomer && !selectedCustomer.__isNew__}
                                                disabled={!!selectedCustomer && !selectedCustomer.__isNew__}
                                            />
                                        </div>

                                        <div className={classes.formGroup}>
                                            <label className={classes.formLabel}>Due Date</label>
                                            <input
                                                type="date"
                                                name="dueDate"
                                                    value={formData.dueDate || ''}
                                                onChange={handleInputChange}
                                                className={classes.formInput}
                                            />
                                        </div>
                                    </div>
                                </div>


                                <div className={classes.threeColumnGrid}>

                                    <div className={classes.flexy}>
                                        <div className={classes.formGroup}>
                                            <label className={classes.formLabel}>Invoice Amount</label>
                                            <CurrencyInput
                                                id="outstanding-credit"
                                                name="outstandingCredit"
                                                value={outstandingCredit}
                                                decimalsLimit={2}
                                                disabled
                                                readOnly
                                                prefix=""
                                                groupSeparator=","
                                                placeholder="Outstanding"
                                                className={`form-control ${classes.optioncss} ${classes.grayedOut}`}
                                                style={{ backgroundColor: "#f3f4f6", color: "#6b7280" }}
                                            />
                                        </div>

                                        <div className={classes.twoColumnGrid}>
                                            <div className={classes.formGroup}>
                                                <label className={classes.formLabel}>Less: Other Deductions</label>
                                                <input
                                                    type="number"
                                                    name="otherDeductions"
                                                value={formData.otherDeductions || ''}
                                                    onChange={handleInputChange}
                                                    step="0.01"
                                                    className={classes.formInput}
                                                />
                                            </div>

                                            <div className={classes.formGroup}>
                                                <label className={classes.formLabel}>Less: Withholding Tax (WHT)</label>
                                                <input
                                                    type="number"
                                                    name="withholdingTax"
                                                value={formData.withholdingTax || ''}
                                                    onChange={handleInputChange}
                                                    step="0.01"
                                                    className={classes.formInput}
                                                />
                                            </div>

                                        </div>
                                    </div>

                                    <div className={classes.flexy}>
                                        <div className={classes.formGroup2}>
                                            <label className={classes.formLabel}>Net Payable Amount</label>
                                            <input
                                                type="text"
                                                name="netPayableAmount"
                                                value={formData.netPayableAmount || ''}
                                                readOnly
                                                className={`${classes.formInput} ${classes.readOnlyInput}`}
                                            />
                                        </div>

                                        <div className={`${classes.formGroup2} ${classes.newstylecur}`}>
                                            <label className={` ${classes.formLabel}`}>Currency:</label>
                                            <Select
                                                options={currencyOptions}
                                                value={selectedCurrency}
                                                onChange={setSelectedCurrency}
                                                placeholder="Currency"
                                                isClearable
                                                classNamePrefix="react-select"
                                                required
                                                className={`${classes.formInput} ${classes.newstylecurinput}`}
                                            />
                                        </div>



                                      
                                    </div>



                                </div>


                            </div>

                            <div className={classes.sectionTitle}>3. Payment Method</div>
                            <div className={classes.paymentMethodOptions}>
                                <label className={classes.radioLabel}>
                                    <input
                                        type="radio"
                                        name="paymentMethod"
                                        checked={selectedPaymentMethodId === 1}
                                        onChange={() => handlePaymentMethodChange(1)}
                                        className={classes.radioInput}
                                    />
                                    Bank Transfer
                                </label>

                                <label className={classes.radioLabel}>
                                    <input
                                        type="radio"
                                        name="paymentMethod"
                                        checked={selectedPaymentMethodId === 2}
                                        onChange={() => handlePaymentMethodChange(2)}
                                        className={classes.radioInput}
                                    />
                                    Cheque
                                </label>

                                <label className={classes.radioLabel}>
                                    <input
                                        type="radio"
                                        name="paymentMethod"
                                        checked={selectedPaymentMethodId === 3}
                                        onChange={() => handlePaymentMethodChange(3)}
                                        className={classes.radioInput}
                                    />
                                    Teller
                                </label>

                                <label className={classes.radioLabel}>
                                    <input
                                        type="radio"
                                        name="paymentMethod"
                                        checked={selectedPaymentMethodId === 4}
                                        onChange={() => handlePaymentMethodChange(4)}
                                        className={classes.radioInput}
                                    />
                                    Cash
                                </label>
                            </div>
                            <div className={classes.customerInformationflx}>

                                <div className={classes.compactRowtackled}>
                                    <label>Bank:</label>
                                    <Select
                                        options={bankOptions}
                                        value={selectedBank}
                                        onChange={setSelectedBank}
                                        placeholder="Account"
                                        isClearable
                                        classNamePrefix="react-select"
                                        className={classes.fullWidth}
                                    />
                                </div>

                                {/* <div className={classes.customerInformationflx}> */}
                                <div className={classes.compactRowtackled}>
                                    <label>Teller No:</label>
                                    <input
                                        type="text"
                                        value={tellerNo}
                                        onChange={e => setTellerNo(e.target.value.replace(/[^0-9]/g, ""))}
                                        placeholder="Enter Teller Number"
                                        className={classes.fullWidth}
                                    />
                                </div>
                                {/* </div> */}

                            </div>
                            <div className={classes.formGroup3}>
                                            <label className={classes.formLabel}>Amount:</label>
                                            <CurrencyInput
                                                id="total-amount"
                                                name="totalAmount"
                                                value={amount}
                                                decimalsLimit={2}
                                                onValueChange={(value) => setAmount(value)}
                                                prefix=""
                                                groupSeparator=","
                                                placeholder="Amount"
                                                className={`form-control ${classes.optioncss}`}
                                            />
                                        </div>
                            {/* Mode select removed; radios above now control payment mode */}




                        </Form.Group>
                    </Form>
                </Modal>

                <div className={classes.tableContainer}>
                    <table className={classes.table}>
                        <thead>
                            <tr className={classes.tableHeader}>
                                <th>Receipt #</th>
                                <th>Customer</th>
                                <th>Date</th>
                                <th>Due Date</th>
                                <th>Amount</th>
                                <th>Method</th>
                                <th>Reference</th>
                                <th>Account</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loadingTable ? (
                                <tr>
                                    <td className={classes.tableCell} colSpan="10" style={{ textAlign: 'center', padding: '16px' }}>Loading...</td>
                                </tr>
                            ) : rows.length === 0 ? (
                                <tr>
                                    <td className={classes.tableCell} colSpan="10" style={{ textAlign: 'center', padding: '16px' }}>No receipts found.</td>
                                </tr>
                            ) : (
                                rows.map((row, index) => (
                                    <tr key={index} className={classes.tableRow}>
                                        <td className={classes.tableCell}>{row.ref}</td>
                                        <td className={classes.tableCell}>{row.customer}</td>
                                        <td className={classes.tableCell}>{row.date}</td>
                                        <td className={classes.tableCell}>{row.dueDate}</td>
                                        <td style={{ textAlign: 'right' }} className={classes.tableCell}>{row.amount}</td>
                                        <td className={classes.tableCell}>
                                            <span className={`${classes.methodButton} ${classes['method' + row.method]}`}>
                                                {row.method}
                                            </span>
                                        </td>
                                        <td className={classes.tableCell}>{row.reference}</td>
                                        <td className={classes.tableCell}>{row.account}</td>
                                        <td className={classes.tableCell}>
                                            <span className={`${classes.statusButton} ${classes['status' + row.status]}`}>
                                                {row.status}
                                            </span>
                                        </td>
                                        <td className={classes.tableCell}>
                                            <Eye size={16} style={{ color: 'rgba(22, 163, 74, 1)' }} />
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

                <table className={classes.footerTable}>
                    <tfoot>
                        <tr>
                            <td className={classes.frston}>First</td>
                            <td className={`${classes.page} ${classes.activePage}`}>1</td>
                            <td className={classes.twono}>2</td>
                            <td className={classes.lastno} >Last</td>
                        </tr>
                    </tfoot>
                </table>

                <div className={classes.lasone}>
                    <div className={classes.paginationDisplay}>Displaying 1 - {rows.length} of {rows.length}</div>
                    <div className={classes.paginationDisplaytwo}>Displaying 1 - {rows.length} of {rows.length}</div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Receipts;
